import React from 'react';
export function StartFreeIncludes() {
  return <section className="py-24 bg-paper border-y border-subtle-gray" data-id="element-3091">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3092">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-3093">
          <div data-id="element-3094">
            <img src="https://images.unsplash.com/photo-1555597408-26bc8e548a46?auto=format&fit=crop&w=1000&q=80" alt="Kids training" className="block rounded-2xl shadow-xl" data-id="element-3095" />
          </div>
          <div data-id="element-3096">
            <h2 className="text-4xl text-ink mb-8" data-id="element-3097">
              What Your Free Week Includes
            </h2>
            <div className="space-y-6" data-id="element-3098">
              {['A personal welcome and introduction to the coaches', 'A full week of age-appropriate beginner classes', "An assessment of your child's goals and needs", 'A clear path forward if you choose to enroll'].map((item, idx) => <div key={idx} className="flex gap-4 items-start" data-id="element-3099">
                  <div className="w-8 h-8 bg-storm-red rounded-full flex items-center justify-center shrink-0 text-white font-bold" data-id="element-3100">
                    {idx + 1}
                  </div>
                  <p className="text-lg text-gray-warm pt-1" data-id="element-3101">{item}</p>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}